import { render } from "./RegistroConsultas.vue?vue&type=template&id=574807bd&scoped=true"
import script from "./RegistroConsultas.vue?vue&type=script&lang=js"
export * from "./RegistroConsultas.vue?vue&type=script&lang=js"

import "./RegistroConsultas.vue?vue&type=style&index=0&id=574807bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574807bd"]])

export default __exports__